/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable unused-imports/no-unused-imports */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import { IRepository } from '../../infrastructure/repository.interface';
import { Injectable } from '@angular/core';
import { ColumnModel, YesNoEnum } from '@shared';
import { WorkspaceDatabaseProvider } from '../workspace-database.provider';
import { RxDocument } from 'rxdb';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { WorkspaceDatabaseKeys } from '../schemas';
import { some } from 'lodash';
import { addRxPlugin } from 'rxdb';
import { RxDBQueryBuilderPlugin } from 'rxdb/plugins/query-builder';
import { PlatformName, PlatformProvider } from '@shared';
addRxPlugin(RxDBQueryBuilderPlugin);

@Injectable()
export class ColumnRepository implements IRepository<ColumnModel> {
	public constructor(private dbProvider: WorkspaceDatabaseProvider, private platformProvider: PlatformProvider) {}

	public async insert(entity: ColumnModel): Promise<void> {
		const database = this.dbProvider.getCurrentDatabaseInstance();
		await database.columns.insert(entity);
	}

	public async bulkInsert(entities: ColumnModel[]): Promise<void> {
		const database = this.dbProvider.getCurrentDatabaseInstance();
		
		// if (this.platformProvider.getPlatform() === PlatformName.ANDROID || this.platformProvider.getPlatform() === PlatformName.IOS) {
		// 	console.log(this.platformProvider.getPlatform() === PlatformName.ANDROID);
		// 	console.log(entities, "bulk insertcolumn", entities.length);
		
		// 	const CHUNK_SIZE = 200;
		
		// 	// Function to create chunks of the array
		// 	const createChunks = (array, chunkSize) => {
		// 		return array.reduce((acc, _, index) => {
		// 			if (index % chunkSize === 0) {
		// 				acc.push(array.slice(index, index + chunkSize));
		// 			}
		// 			return acc;
		// 		}, []);
		// 	};

		// 	const chunks = createChunks(entities, CHUNK_SIZE);
		// 	if(chunks.length < 3) {
		// 		for (const item of chunks) {
		// 			await database.columns.bulkInsert(item);
		// 			await new Promise(resolve => setTimeout(resolve, 100));
		// 		}
		// 	} else {
		// 		const data = chunks[chunks.length - 1]
		// 		const newChunks = createChunks(data, 5);
		// 		for(let i = 0; i <newChunks.length; i++) {
		// 			try {
		// 				await database.columns.bulkInsert(newChunks[i]);
		// 				await new Promise(resolve => setTimeout(resolve, 100));
		// 			} catch (error) {
		// 				console.log(newChunks[i], "err");
		// 				break;
		// 			}
		// 		}
		// 		await new Promise(resolve => setTimeout(resolve, 1000));
		// 		const restData = chunks.slice(0, chunks.length - 1);
		// 		for (const item of restData) {
		// 			await database.columns.bulkInsert(item);
		// 			await new Promise(resolve => setTimeout(resolve, 100));
		// 		}
		// 	}
		// }
		
		// if(this.platformProvider.getPlatform() !== PlatformName.ANDROID) {
		// 	await database.columns.bulkInsert(entities);
		// }
		
		for (const item of entities) {
			try {
				await database.columns.insert(item);
			} catch (error) {}
		}
	}
	
	public getColumns$(tableName: string): Observable<ColumnModel[]> {
		const database = this.dbProvider.getCurrentDatabaseInstance().columns;
		return database
			.find()
			.where(WorkspaceDatabaseKeys.tables.tableName.toLowerCase())
			.eq(tableName)
			.$.pipe(
				map((dataColumns: RxDocument<ColumnModel>[]) =>
					dataColumns.map((dataColumn: RxDocument<ColumnModel>) => dataColumn.toJSON())
				)
			);
	}

	public getAllColumns$(): Observable<ColumnModel[]> {
		const database = this.dbProvider.getCurrentDatabaseInstance().columns;
		return database.find().$.pipe(
			map((dataColumns: RxDocument<ColumnModel>[]) =>
				dataColumns.map((dataColumn: RxDocument<ColumnModel>) => {
					const column = dataColumn.toJSON();
					delete column['_id']; // eslint-disable-line
					return column;
				})
			)
		);
	}

	public hasInheritedColumns$(tableName: string): Observable<boolean> {
		return this.getColumns$(tableName).pipe(
			map((colums: ColumnModel[]) =>
				some(
					colums,
					(colum: ColumnModel) =>
						colum[WorkspaceDatabaseKeys.columns.inheritValues] === YesNoEnum.Yes.toString()
				)
			)
		);
	}

	public hasDepthsColumns$(tableName: string): Observable<boolean> {
		return this.getColumns$(tableName).pipe(
			map((colums: ColumnModel[]) => {
				const depthColumns: ColumnModel[] = colums.filter(
					(column: ColumnModel) =>
						column.column_name === WorkspaceDatabaseKeys.columns.depthFrom ||
						column.column_name === WorkspaceDatabaseKeys.columns.depthTo
				);

				return depthColumns.length === 2;
			})
		);
	}
}
